import React from 'react'

import { Col, Row, Tabs } from 'antd'

import CompanyCandidateList from './CompanyCandidateList'

export const CandidateTabs = ({ topAlumni, topRecruiters }) => {
  const TabPane = /** @type {any} */ (Tabs.TabPane)

  return (
    <Row>
      <Col>
        <Tabs
          defaultActiveKey="1"
          className="sidebar-tabs"
          renderTabBar={(props, DefaultTabBar) => (
            <DefaultTabBar
              {...props}
              renderTabBarNode={node =>
                React.cloneElement(node, {
                  'aria-controls': `tabpanel-ct-${node.key}`,
                  id: `tab-ct-${node.key}`,
                })
              }
            />
          )}
        >
          {topAlumni.length && (
            <TabPane
              tab="Top Alumni"
              key="1"
              id="tabpanel-ct-1"
              aria-labelledby="tab-ct-1"
              className="sidebar-tab"
            >
              <CompanyCandidateList
                candidates={topAlumni}
                // handleCandidateClick={getCandidateDetails}
              />
            </TabPane>
          )}

          {topRecruiters.length && (
            <TabPane
              tab="Top Recruiters"
              key="2"
              id="tabpanel-ct-2"
              aria-labelledby="tab-ct-2"
              className="sidebar-tab"
            >
              <CompanyCandidateList
                candidates={topRecruiters}
                // handleCandidateClick={getCandidateDetails}
              />
            </TabPane>
          )}
        </Tabs>
      </Col>
    </Row>
  )
}

export default CandidateTabs
